import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

export default {
  components: {
    NuxtClientOnly: () => import('@motionelements/core/src/components/nav/NuxtClientOnly.vue'),
  },
  mixins: [featureFlagMixin],
  computed: {
    showStudioAiLink() {
      return this.isFeatureEnabled('studio_ai');
    },
  },
};
